export function getToken() {
    return localStorage.getItem('token_info') ? localStorage.getItem('token_info') : ''
}
export function setToken(token) {
    return localStorage.setItem('token_info',token)
}

export function clearStorage() {
    return localStorage.clear()
}

export function removeStorage(key) {
    return localStorage.removeItem(key) ? localStorage.removeItem(key):''
}

export function cache(key, value) {
    if (value == null) {
        value = localStorage.getItem(key)
        if (value == null) {
            return null
        }
        value = JSON.parse(value)
        return value["data"];
    }
    localStorage.setItem(key, null)
    localStorage.setItem(key, JSON.stringify({ data: value }))
}